<template>
  <div class="search-wrap">
    <header class="search-wrap__header">
      <af-h1 noUnderline>Sök kompetens i Jobskills</af-h1>
    </header>

    <search-field></search-field>
    <search-results></search-results>
    <search-scroll-to-top></search-scroll-to-top>

    <div class="information-boxes">
      <af-information-box image="static/img/hitta_ratt.svg">
        <template slot="title">Hitta rätt person för jobbet</template>
        <template slot="content">I Jobskills kandidatbank kan du söka bland många arbetssökande. De som
matchar dina önskemål bäst visas högst upp i sökresultatet. Du kan ändra
din sökning genom att lägga till eller ta bort val för att få en bättre
matchning.</template>
      </af-information-box>

      <af-information-box
        image="static/img/ta_kontakt.svg"
        linkUrl="/arbetsgivarinformation">
        <template slot="title">Ta kontakt och anställ</template>
        <template slot="content">När du har hittat en person som passar kan du använda kontaktuppgifterna på personens profil och ta kontakt. Läs mer om vad som gäller när du anställer asylsökande och nyanlända så att du kan känna dig trygg i din roll som arbetsgivare. </template>
       <template slot="link">Läs mer om att anställa personer som är nya i Sverige</template>
      </af-information-box>
    </div>
  </div>
</template>

<script>
import SearchField from './SearchField'
import SearchResults from './SearchResults'
import AfInformationBox from '@/components/AfInformationBox'
import AfH1 from '@/components/AfH1'
import SearchScrollToTop from './SearchScrollToTop'

export default {
  name: 'Search',
  components: {
    AfH1,
    AfInformationBox,
    SearchField,
    SearchResults,
    SearchScrollToTop
  }
}
</script>

<style lang="postcss" scoped>
@import '../../variables/custom-media.css';

.search-wrap {
  margin-left: auto;
  margin-right: auto;
  margin-top: var(--spacing);
  max-width: var(--spacing-max-width-large);
  padding: var(--spacing-half);

  @media (--bp-larger-than-tablet) {
    margin-top: 70px;
    padding: 0;
  }
}

.search-wrap__header {
  display: none;
  margin-bottom: var(--spacing-huge);

  @media (--bp-larger-than-tablet) {
    display: block;
  }
}


.information-boxes {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: var(--spacing-huge);
}
</style>



// WEBPACK FOOTER //
// src/views/Search/Search.vue